// assets/js/modules/serviceCarousel.js

let _carousels = [];

function initCarousel(el, startDelay = 0) {
    const track  = el.querySelector('.service-block__track');
    const dots   = Array.from(el.querySelectorAll('.service-block__dot'));
    const slides = Array.from(el.querySelectorAll('.service-block__slide'));

    if (!track || slides.length < 2) return null;

    let current = 0;
    let timer = null;
    let initTimeout = null;

    function goTo(index) {
        current = (index + slides.length) % slides.length;
        track.style.transform = `translateX(-${current * 100}%)`;
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === current));
    }

    function startAutoPlay() {
        timer = setInterval(() => goTo(current + 1), 2000);
    }

    function resetAutoPlay() {
        clearInterval(timer);
        startAutoPlay();
    }

    dots.forEach((dot, i) => dot.addEventListener('click', () => {
        goTo(i);
        resetAutoPlay();
    }));

    goTo(0);
    initTimeout = setTimeout(startAutoPlay, startDelay);

    return {
        destroy() {
            clearTimeout(initTimeout);
            clearInterval(timer);
        }
    };
}

export function init() {
    _carousels = [];
    document.querySelectorAll('[data-service-carousel]').forEach((el, i) => {
        const instance = initCarousel(el, i * 1000);
        if (instance) _carousels.push(instance);
    });
}

export function destroy() {
    _carousels.forEach(c => c.destroy());
    _carousels = [];
}
